import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  DeviceProfile,
  DeviceProfileDevice,
  DeviceProfileVendor,
  CreateDeviceProfileRequest,
} from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";
import type { CreateDeviceProfileResponse } from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";

import DeviceProfileForm from "./DeviceProfileForm";
import deviceProfileStore from "../../stores/DeviceProfileStore";
import { useTitle } from "../helpers";

interface IProps {
  vendor: DeviceProfileVendor;
  device: DeviceProfileDevice;
}

function CreateDeviceProfileTemplate(props: IProps) {
  useTitle(
    "Network Server",
    "Device Profiles",
    "Vendors",
    props.vendor.getName(),
    props.device.getName(),
    "Add profile",
  );
  const navigate = useNavigate();

  const onFinish = (dp: DeviceProfile) => {
    // Server distinguishes templates from tenant DPs by tenant_id="" + device_id set.
    dp.setTenantId("");
    dp.setDeviceId(props.device.getId());

    const req = new CreateDeviceProfileRequest();
    req.setDeviceProfile(dp);

    deviceProfileStore.create(req, (resp: CreateDeviceProfileResponse) => {
      navigate(
        `/device-profiles/vendors/${props.vendor.getId()}/devices/${props.device.getId()}/profiles/${resp.getId()}`,
      );
    });
  };

  const initial = new DeviceProfile();
  initial.setDeviceId(props.device.getId());
  initial.setName(props.device.getName());
  initial.setPublished(true);

  return (
    <Space orientation="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb
            items={[
              { title: "Network Server" },
              { title: "Device Profiles" },
              { title: <Link to="/device-profiles/vendors">Vendors</Link> },
              {
                title: (
                  <Link to={`/device-profiles/vendors/${props.vendor.getId()}/devices`}>{props.vendor.getName()}</Link>
                ),
              },
              {
                title: (
                  <Link
                    to={`/device-profiles/vendors/${props.vendor.getId()}/devices/${props.device.getId()}/profiles`}
                  >
                    {props.device.getName()}
                  </Link>
                ),
              },
              { title: "Add profile" },
            ]}
          />
        )}
        title="Add device profile"
      />
      <Card>
        <DeviceProfileForm initialValues={initial} onFinish={onFinish} isTemplate />
      </Card>
    </Space>
  );
}

export default CreateDeviceProfileTemplate;
